import { createSlice } from "@reduxjs/toolkit";
import {
  getBanners,
  getBannerById,
  createBanner,
  updateBanner,
  deleteBanner,
} from "./bannerThunks";

const initialState = {
  banners: [],
  selectedBanner: null,
  loading: false,
  error: null,

  createLoading: false,
  createSuccess: false,
  createError: null,

  updateLoading: false,
  updateSuccess: false,
  updateError: null,

  deleteLoading: false,
  deleteSuccess: false,
  deleteError: null,
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    clearBannerState: (state) => {
      state.banners = [];
      state.loading = false;
      state.error = null;
    },
    resetBannerStatus: (state) => {
      state.createLoading = false;
      state.createSuccess = false;
      state.createError = null;
      state.updateLoading = false;
      state.updateSuccess = false;
      state.updateError = null;
      state.deleteLoading = false;
      state.deleteSuccess = false;
      state.deleteError = null;
      state.error = null;
    },
    clearUpdateState: (state) => {
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
    },
    clearDeleteState: (state) => {
      state.deleteLoading = false;
      state.deleteError = null;
      state.deleteSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET BANNERS
      .addCase(getBanners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
          ? action.payload
          : [];
      })
      .addCase(getBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BANNER BY ID
      .addCase(getBannerById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBannerById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBanner = action.payload?.data || null;
      })
      .addCase(getBannerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE BANNER
      .addCase(createBanner.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
        state.createSuccess = false;
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
        if (action.payload?.data) {
          state.banners.unshift(action.payload.data);
        }
      })
      .addCase(createBanner.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
        state.createSuccess = false;
      })

      // UPDATE BANNER
      .addCase(updateBanner.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateBanner.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        const id = action.payload?.id;
        const updatedData = action.payload?.data?.data;
        if (id && updatedData) {
          const index = state.banners.findIndex((b) => b.id === id);
          if (index !== -1) {
            state.banners[index] = { ...state.banners[index], ...updatedData };
          }
        }
      })
      .addCase(updateBanner.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
        state.updateSuccess = false;
      })

      // DELETE BANNER
      .addCase(deleteBanner.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        const id = action.payload?.id ?? action.meta?.arg;
        if (id) {
          state.banners = state.banners.filter((banner) => banner.id !== id);
        }
      })
      .addCase(deleteBanner.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
        state.deleteSuccess = false;
      });
  },
});

export const {
  clearBannerState,
  resetBannerStatus,
  clearUpdateState,
  clearDeleteState,
} = bannerSlice.actions;
export default bannerSlice.reducer;

